/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Microsoft_AspNetCore_Mvc_Rendering_SelectListItem } from '../models/Microsoft_AspNetCore_Mvc_Rendering_SelectListItem';
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsDto';
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto';
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsPageDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsPageDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VendorTermsAndConditionsService {

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiCustomerApiVendorTermsAndConditions(
formData?: {
PageId: string;
Name: string;
DocumentContent?: string;
IsActive: boolean;
Document?: Blob;
AgreementStatement: string;
CompanyId?: string;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/vendor-terms-and-conditions',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiCustomerApiVendorTermsAndConditions(
formData?: {
Id: string;
PageId: string;
Name: string;
DocumentContent?: string;
IsActive: boolean;
Document?: Blob;
AgreementStatement: string;
IsDocumentRemoved: boolean;
CompanyId?: string;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/vendor-terms-and-conditions',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditions(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiVendorTermsAndConditions(
id: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/vendor-terms-and-conditions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditions1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsPageDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditionsPages(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsPageDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions/pages',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Microsoft_AspNetCore_Mvc_Rendering_SelectListItem OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditionsBrokers(): CancelablePromise<Array<Microsoft_AspNetCore_Mvc_Rendering_SelectListItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions/brokers',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
